export const API = process.env.REACT_APP_BACKEND;
export const BACKEND_URL = (process.env.REACT_APP_BACKEND || "").replace(/\/api\/?$/, "");
